const TRENDING_ITEMS = [
  {
    image: "https://public.readdy.ai/ai/img_res/7321acde1d74191942d6ca88b9159b76.jpg",
    alt: "Umrah Packages Now Available",
    href: "/umrah",
    label: "Umrah Packages",
    sub: "Now Available",
  },
  {
    image: "https://readdy.ai/api/search-image?query=passport%20visa%20stamp%20travel%20documents%20world%20map%20international%20travel%20approval%20tourist%20visa%20application%20easy%20process%20colorful%20vibrant%20simple%20clean%20background&width=600&height=360&seq=trending-visa-001&orientation=landscape",
    alt: "Get a Tourist Visa with Ease",
    href: "/visa",
    label: "Tourist Visas",
    sub: "Get Yours with Ease",
  },
  {
    image: "https://readdy.ai/api/search-image?query=global%20airline%20ticketing%20booking%20system%20airport%20terminal%20departures%20board%20flights%20worldwide%20travel%20agent%20professional%20GDS%20computer%20screen%20modern%20office%20Pakistan%20aviation&width=600&height=360&seq=trending-ticketing-001&orientation=landscape",
    alt: "Global Ticketing Available - US Based GDS",
    href: "/services",
    label: "Global Ticketing",
    sub: "US Based GDS",
  },
  {
    image: "https://readdy.ai/api/search-image?query=air%20ticketing%20course%20training%20Lahore%20classroom%20students%20learning%20airline%20reservation%20system%20professional%20certification%20travel%20agency%20Pakistan%20education%20certificate%20program&width=600&height=360&seq=trending-course-001&orientation=landscape",
    alt: "Air Ticketing Course in Lahore",
    href: "/services",
    label: "Ticketing Course",
    sub: "Enroll in Lahore",
  },
];

export default function TrendingSection() {
  return (
    <section className="py-10 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl font-bold text-gray-900 text-center mb-8">Trending Now</h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
          {TRENDING_ITEMS.map(item => (
            <a
              key={item.href + item.label}
              href={item.href}
              className="block rounded-lg overflow-hidden cursor-pointer hover:opacity-90 transition-opacity relative group"
            >
              <div className="w-full h-44">
                <img
                  src={item.image}
                  alt={item.alt}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              {/* Gradient overlay + label */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent flex flex-col justify-end p-3">
                <p className="text-white text-sm font-bold leading-tight">{item.label}</p>
                <p className="text-white/80 text-xs mt-0.5">{item.sub}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
